// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__756Ac","card":"Cards_card__26c3e","infected":"Cards_infected__1vE4e","recovered":"Cards_recovered__2QLZg","deaths":"Cards_deaths__2UX_z"};